import { ExclamationCircleOutlined } from '@ant-design/icons';
import { AppLoader } from 'shared/UI/UIKit/Loader';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { StickyScrollbar, useStickyHorizontalScrollbar } from 'shared/UI/UIKit/StickyScrollbar';
import { useScheduleGrid } from '../model';
import {
  TableHeader,
  ScheduleRow,
  LessonDetails,
  ConstraintsTable,
  RefineModal,
  StatusTag,
  Toolbar,
  EditModeToolbar,
} from './components';
import styles from './styles.module.scss';

export const Schedule = () => {
  const {
    state: {
      scheduleIsLoading,
      configurationId,
      scheduleId,
      scheduleConstraints,
      refineModalOpen,
      scheduleProcessing,
      editMode,
    },
    methods: { setRefineModalOpen, handleRefineSuccess },
  } = useScheduleGrid();
  const { hasOverflow, tableRef, tableWrapperRef, stickyScrollbarRef, stickyScrollbarContentRef } =
    useStickyHorizontalScrollbar({ isDisabled: scheduleIsLoading });

  if (scheduleIsLoading) {
    return <AppLoader size="large" stretched />;
  }

  return (
    <>
      <AppFlex direction="column" unit="16">
        <AppFlex direction="column" unit="16">
          <AppFlex
            direction="row"
            justifyContent="flex-end"
            unit="16"
            alignItems="center"
            className={scheduleProcessing ? styles.processing : ''}
          >
            {scheduleProcessing && (
              <AppFlex direction="row" alignItems="center" unit="8">
                <ExclamationCircleOutlined style={{ fontSize: '16px' }} />
                <span>Расписание генерируется</span>
              </AppFlex>
            )}
          </AppFlex>
          <AppFlex direction="row" justifyContent="space-between" unit="16" alignItems="flex-start">
            <ConstraintsTable />
            <StatusTag />
          </AppFlex>
        </AppFlex>
        <Toolbar scheduleProcessing={scheduleProcessing} setRefineModalOpen={setRefineModalOpen} />
      </AppFlex>
      <div className={styles.tableArea}>
        <div className={styles.tableWrapper} ref={tableWrapperRef} data-schedule-table-scroll>
          <table className={styles.table} ref={tableRef}>
            <TableHeader />
            <ScheduleRow />
          </table>
        </div>
        <StickyScrollbar
          hasOverflow={hasOverflow}
          stickyScrollbarRef={stickyScrollbarRef}
          stickyScrollbarContentRef={stickyScrollbarContentRef}
        />
      </div>
      <LessonDetails />
      <RefineModal
        open={refineModalOpen}
        onClose={() => setRefineModalOpen(false)}
        onSuccess={handleRefineSuccess}
        configurationId={configurationId}
        timetableId={scheduleId}
        initialConstraints={scheduleConstraints}
      />
      {editMode && <EditModeToolbar />}
    </>
  );
};
